import React from 'react';
import Section from './common/Section';
import avatar1 from '../assets/avatar1.jpg';
import avatar2 from '../assets/avatar2.jpg';
import avatar3 from '../assets/avatar3.jpg';

function Testimonials() {
  const TESTIMONIALS = [
    {
      id: 1,
      image: avatar1,
      name: 'Stella',
      comment: 'He always deliver amazing job and as at when due',
    },
    {
      id: 2,
      image: avatar2,
      name: 'Florence',
      comment: 'Nice job',
    },
    {
      id: 3,
      image: avatar3,
      name: 'Robert',
      comment:
        'His works are good. He goes extra-mile to make sure that clients  are satisfied.',
    },
  ];
  return (
    <Section
      title="Testimonials 🎨"
      subtitle="This is what my other clients have to say about me. I accept clients from all around the world."
    >
      <div className="max-w-xl flex flex-col gap-8">
        {TESTIMONIALS.map(({ id, image, name, comment }) => (
          <div
            key={id}
            className="flex p-4 justify-center items-center rounded-xl shadow-md dark:shadow-gray-300"
          >
            <div className="w-1/3">
              <img
                src={image}
                alt={name}
                className="w-20 h-20 object-cover object-top pt-2 rounded-xl"
                loading="lazy"
              />
            </div>
            <div className="w-2/3 flex flex-col justify-center items-center gap-3 p-2">
              <h3 className="text-xl font-semibold">{name}</h3>
              <p className="text-sm font-extralight">{comment}</p>
            </div>
          </div>
        ))}
      </div>
    </Section>
  );
}

export default Testimonials;
